import { component } from 'flightjs';
import InitData from 'tradera/legacy/static/app/data/init-data';

function TrackLoginEvent() {
    this.defaultAttrs({
        eventType: 'password-recovery',
        categoryName: '[data-login-flow-name]',
        errorMessage: '[data-input-error]'
    });

    this._triggerPasswordRecoveryEvents = function () {
        const categoryName =
            this.select('categoryName').data('login-flow-name');
        const errorMessage = this.select('errorMessage');

        if (
            errorMessage.length > 0 &&
            errorMessage.data('input-error').length > 0
        ) {
            this._triggerErrorEvent(categoryName, errorMessage);
            return;
        }

        this.trigger(document, 'analytics:track-event', {
            category: categoryName,
            action: 'Navigation',
            label: InitData.current().pageName,
            userTriggered: true
        });
    };

    this._triggerErrorEvent = function (categoryName, errorMessage) {
        this.trigger(document, 'analytics:track-event', {
            category: categoryName,
            action: 'Error',
            label:
                InitData.current().pageName +
                ' : ' +
                errorMessage.data('input-error'),
            userTriggered: true
        });
    };

    this._triggerLoginEvent = function () {
        const errorMessage = this.select('errorMessage');

        if (errorMessage.length > 0) {
            this._triggerErrorEvent('Login', errorMessage);
            return;
        }

        this.trigger(document, 'analytics:track-event', {
            category: 'Login',
            action: 'Navigation',
            label: 'Login Page (V2)',
            userTriggered: true
        });
    };

    this.after('initialize', function () {
        if (this.attr.eventType === 'password-recovery') {
            this._triggerPasswordRecoveryEvents();
        } else {
            this._triggerLoginEvent();
        }
    });
}

export default component(TrackLoginEvent);
